// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"IX","mainContent":"JX","activeSidebar":"KX"};